module.exports = __webpack_public_path__ + "img/arrow-right.6b3fc403.svg";